import { Gender } from '../models/gender.enum';

// Type guard for Gender
export const isValidGender = (g: unknown): g is Gender => {
  return g === Gender.M || g === Gender.F;
};
